import { createReducer } from 'shared';
import { fetchAppQrRelations } from 'redux/actions';

export const appQrRelationsEntitiesReducer = createReducer(
  {},
  {
    [fetchAppQrRelations]: (entities, action) => ({ ...entities, ...action.entities }),
  }
);
